<div class="root">
  <div class="top">
    <div class="top-content container">
      <div class="top-item">
        <app-icon-with-text [firstText]="'Atendimento Telefônico'" [secondText]="'(51) 3288-1550'"
          [iconName]="'phone'"></app-icon-with-text>
      </div>

      <div *ngIf="!isDesktop" class="top-divider-container">
        <app-divider></app-divider>
      </div>

      <div class="top-item">
        <app-icon-with-text [firstText]="'Atendimento'" [secondText]="'Veja mais solicitações'"
          [iconName]="'messages-square'" [isLink]="true" [isExternalLink]="true"
          [linkRoute]="digitalAssistanceLink"></app-icon-with-text>
      </div>

      <div *ngIf="!isDesktop" class="top-divider-container">
        <app-divider></app-divider>
      </div>

      <div class="top-item">
        <app-icon-with-text [firstText]="'Atendimento Presencial'" [secondText]="'Agende seu Atendimento'"
          [iconName]="'store'" [isLink]="true" [isExternalLink]="true"
          [linkRoute]="inPersonAssistanceLink"></app-icon-with-text>
      </div>
    </div>
  </div>

  <div class="mid">
    <div class="mid-content container">
      <div class="logo-container">
        <img class="logo" src="./assets/images/Logo.svg" alt="Logo" />

        <div>
          <span class="text highlight-text">IPE Saúde</span>
          <span class="text">Av. Borges de Medeiros, 1945 | Praia de Belas, Porto Alegre – RS | CEP 90010-260</span>
          <span class="text">Acesso para cadeirantes e pessoas com mobilidade reduzida pela Rua Vicente de Paula
            Dutra.</span>
        </div>
      </div>

      <div *ngIf="!isDesktop" class="mid-divider-container">
        <app-divider></app-divider>
      </div>

      <app-footer-social-medias />
    </div>
  </div>

  <div class="bottom">
    <img class="bottom-image" [src]="bottomImageFilePath" alt="Procergs" />
  </div>
</div>